import { Dropdown } from "antd";
import CalenderIcon from "common/icons/CalenderGreen.svg";
import CrossIcon from "common/icons/CrossGreen.svg";
import EditCalenderIcon from "common/icons/EditCalenderGreen.svg";
import RadioCheck from "common/icons/RadioCheckGreen.svg";
import RadioUncheck from "common/icons/RadioUncheckGreen.svg";
import dayjs from "dayjs";
import { t } from "i18next";
import { useEffect, useState } from "react";
import styled from "styled-components";
import DateRangeModal, { dateRangeModalProps } from "./DateRangeModal";
import { StyledAntdModal } from "./StyledElements";

const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between; /* 187.5% */
  padding: 16px;
  width: 200px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid rgba(0, 87, 84, 0.1);
  background: linear-gradient(180deg, #fff 0%, #f5f5f5 100%);
  box-shadow: 0px 4px 6px -3px rgba(154, 188, 187, 0.6);
  cursor: pointer;
  @media screen and (max-width: 1279px) {
    width: 160px;
    height: 38px;
    padding: 12px;
  }
`;
const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
  color: #005754;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  white-space: nowrap;
  @media screen and (max-width: 1280px) {
    font-size: 12px;
    column-gap: 8px;
  }
`;

const MenuTitle = styled.div`
  color: #005754;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  width: 174px;
  border: 1px solid rgba(0, 87, 84, 0.1);
  background: ${(props) =>
    props.highlight
      ? "#ebebe9"
      : "linear-gradient(180deg, #fff 0%, #f5f5f5 100%)"};
  padding: 8px;
  white-space: pre-wrap;
`;
const LabelContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  color: #2e2e2e;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;
const Img = styled.img`
  width: 24px;
  height: 24px;
  @media screen and (max-width: 1280px) and (min-width: 1024px) {
    width: 20px;
    height: 20px;
  }
  @media screen and (max-width: 1023px) {
    width: 18px;
    height: 18px;
  }
`;

const dateFilterData = [
  {
    key: "today",
    label: t("Today"),
    value: 0
  },
  {
    key: "Last 7 Days",
    label: t("Last 7 Days"),
    value: 7
  },
  {
    key: "Last 30 Days",
    label: t("Last 30 Days"),
    value: 30
  },
  {
    key: "Last 90 Days",
    label: t("Last 90 Days"),
    value: 90
  },
  {
    key: "Last 365 Days",
    label: t("Last 365 Days"),
    value: 365
  },
  {
    key: "Custom Dates",
    label: t("Custom Dates"),
    icon: EditCalenderIcon,
    value: "custom",
    showBackground: true
  }
];

const defaultPagination = { pageSize: 10, currentPage: 0 };

const CustomDateFilter = (props) => {
  const {
    pagination = defaultPagination,
    setPagination = () => {},
    selectedDates,
    setSelectedDates
  } = props;
const [selectedFilterKey, setSelectedFilterKey] = useState(null);

const [dateLabel, setDateLabel] = useState(() => {
  const start = dayjs(selectedDates[0]);
  const end = dayjs(selectedDates[1]);
  const today = dayjs().endOf("day");

  if (end.isSame(today, "day")) {
    const diff = end.diff(start, "day");
    return diff === 0 ? t("Today") : `Last ${diff} Days`;
  }
  return "Custom Dates";
});

  const [showDateModal, setShowDateModal] = useState(false);

useEffect(() => {
  const start = dayjs(selectedDates[0]);
  const end = dayjs(selectedDates[1]);
  const today = dayjs().endOf("day");

  if (end.isSame(today, "day")) {
    const diff = end.diff(start, "day");

    const matched = dateFilterData.find(
      (item) => item.value === diff
    );

    if (matched) {
      setSelectedFilterKey(matched.key);
      setDateLabel(matched.label);
      return;
    }
  }

  setSelectedFilterKey("Custom Dates");
  setDateLabel(t("Custom Dates"));
}, [selectedDates]);



const handleOptionChange = (item) => {
  setPagination({
    currentPage: 0,
    pageSize: pagination.pageSize
  });

  setSelectedFilterKey(item.key);

  if (item.value === "custom") {
    setShowDateModal(true);
  } else {
    setSelectedDates([
      dayjs().subtract(item.value, "d").format("YYYY-MM-DD"),
      dayjs().format("YYYY-MM-DD")
    ]);
    setDateLabel(item.label);
  }
};


  const getMenuItem = [
    {
      key: "title",
      label: <MenuTitle>{t("filter order date")}</MenuTitle>,
      type: "group"
    },
    ...dateFilterData.map((item) => ({
      key: item.key,
      label: (
        <MenuContainer>
          <Img
  src={
    item?.icon ??
    (selectedFilterKey === item.key
      ? RadioCheck
      : RadioUncheck)
  }
  alt="radio"
/>

          <LabelContainer>{t(item.label)}</LabelContainer>
        </MenuContainer>
      ),
      onClick: () => handleOptionChange(item)
    }))
  ];

  const handleCloseModal = () => {
    setShowDateModal(false);
  };

const handleSelectDates = (dates) => {
  if (dates) {
    setSelectedDates([
      dates[0].format("YYYY-MM-DD"),
      dates[1].format("YYYY-MM-DD")
    ]);
    setSelectedFilterKey("Custom Dates");
    setDateLabel(t("Custom Dates"));
    handleCloseModal();
  }
};


  return (
    <div>
      <Dropdown menu={{ items: getMenuItem }} trigger={["click"]}>
        <FiltersContainer>
          <ContentContainer>
            <Img src={CalenderIcon} alt="dateFiler" />
            {dateLabel}
          </ContentContainer>
          <span>▼</span>
        </FiltersContainer>
      </Dropdown>
      <StyledAntdModal
        open={showDateModal}
        onCancel={handleCloseModal}
        closeIcon={<img width={30} height={30} src={CrossIcon} alt="close" />}
        {...dateRangeModalProps}
      >
        <DateRangeModal
          buttonTitle={t("Select Dates")}
          handleOnClick={handleSelectDates}
        />
      </StyledAntdModal>
    </div>
  );
};

export default CustomDateFilter;